"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestimonialCard = void 0;
var React = require("react");
var core_1 = require("@material-ui/core");
var styles_1 = require("@/pages/testimonials/components/TestimonialCard/styles");
var star_1 = require("@/utils/star");
exports.TestimonialCard = function (props) {
    var testimonial = props.testimonial, authorName = props.authorName, authorTitle = props.authorTitle, agentImageUrl = props.agentImageUrl, agentName = props.agentName, agentUrl = props.agentUrl, agentRate = props.agentRate, t = props.t;
    var handleAgentClick = function () {
        window.location.href = agentUrl;
    };
    var getAuthorTitle = function (authorTitle) {
        if (authorTitle && authorTitle.length > 0) {
            return React.createElement(styles_1.AuthorTitle, null, authorTitle);
        }
        return null;
    };
    var renderAgentInfo = function () { return (React.createElement(styles_1.AgentContainer, null,
        React.createElement(styles_1.AgentInfo, null,
            React.createElement(styles_1.AgentName, { onClick: handleAgentClick }, agentName),
            React.createElement(styles_1.AgentViewMore, { onClick: handleAgentClick }, t.viewMore)),
        React.createElement(styles_1.AgentImage, { width: 100, height: 100, src: agentImageUrl, onClick: handleAgentClick }))); };
    var renderRating = function (rate) {
        return (React.createElement("div", { className: "c-testimonials__rating", style: { alignItems: 'flex-start', marginLeft: '29px' } },
            React.createElement("div", { className: "c-homereview__stars" }, star_1.renderStars(agentRate)),
            React.createElement("div", { className: "c-homereview__score" },
                agentRate,
                " / 5.0")));
    };
    return (React.createElement(styles_1.Root, null,
        React.createElement(styles_1.ContentContainer, null,
            React.createElement(styles_1.QuoteOpenContainer, null,
                React.createElement(styles_1.Quote, null, "\u275D")),
            React.createElement(styles_1.ContentText, null, testimonial),
            React.createElement(core_1.Hidden, { smDown: true },
                React.createElement(styles_1.QuoteCloseContainer, null,
                    React.createElement(styles_1.Quote, null, "\u275E")))),
        React.createElement(styles_1.Author, null, authorName.toLowerCase()),
        getAuthorTitle(authorTitle),
        agentRate ? renderRating(agentRate) : null,
        renderAgentInfo()));
};
